
  <span
    data-testid="media-monitor"
    [ngClass]="changeClass ? 'mediaM' : ''"
    [matBadge]="badgeM"
    id="badgeM"
    matBadgeSize="small"
    *ngIf="containsMM"
  >
  </span>
  <span
    data-testid="stream"
    id="badgeS"
    [ngClass]="{
      soundPlus: changeClass,
      leftSpaceSoundplus: !containsMM
    }"
    [matBadge]="streamQuant"
    matBadgeSize="small"
    *ngIf="containsStream"
  >
  </span>

